import React from "react";
import "./PipesBar.scss";

const PipeSection = ({ pipe, index, setPipeId, handlePipePopupOpen }) => {
  // Get left and right gates based on local_id
  const leftGate = pipe.gates.find(g => g.local_id === 0);
  const rightGate = pipe.gates.find(g => g.local_id === 1);

  return (
    <div
      onClick={() => {
        setPipeId(pipe.id);
        handlePipePopupOpen(true);
      }}
      key={index}
      className="pipe-section-card"
    >
      <p className="pipe-column-id-label">Pipe {pipe.local_id}</p>

      <div className="pipe-column-container">
        <div className={`pipe-left ${leftGate?.open ? "open" : "closed"}`}>
          Left
        </div>

        <div className={`pipe-right ${rightGate?.open ? "open" : "closed"}`}>
          Right
        </div>
      </div>
    </div>
  );
};

const PipesBar = ({ fieldId, pipes, setPipeId, handlePipePopupOpen }) => (
  <div className="PipesBar">
    {pipes
      .filter(pipe => pipe.field_id === fieldId)
      .sort((a, b) => a.local_id - b.local_id)
      .map((pipe, index) => (
        <PipeSection
          pipe={pipe}
          index={index}
          setPipeId={setPipeId}
          handlePipePopupOpen={handlePipePopupOpen}
          key={pipe.id}
        />
      ))}
  </div>
);

export default PipesBar;
